import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import styled from "@emotion/styled";
import Layout from "views/universal/Layout/Layout";
import { savOperations } from "state/ducks/store/sav";
import { Tabs, Tab, Badge, OverlayTrigger, Tooltip } from "react-bootstrap";
import HelpDocumentation from "views/universal/Layout/HelpDocumentation"
import { getAllUrlParams, removeURLParameter } from "utils/utils"
import Message from "./Message/Message"
import CreditPool from "./CreditPool/CreditPool"
import Intendance from "./Intendance/Intendance"
import Reclasser from "./Reclasser/Reclasser"

const Sav = (props) => {

  const urlParams = getAllUrlParams(props.location.search);
  // ?savId= : lien « éditer la catégorie » posé dans le dashboard de pilotage.
  // Il ouvre d'office l'onglet de reclassement, pour que le lien reste simple.
  // ⚠️ getAllUrlParams met les clés en minuscules : `savId` arrive en `savid`.
  const savId = urlParams.savid;
  const [topic, setTopic] = useState(savId ? "reclasser" : urlParams.topic);

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(savOperations.initPage());
  }, [dispatch]);

  // useEffect(() => {
  //   let search = removeURLParameter(props.location.search, 'topic');
  //   props.history.push({
  //     pathname: props.location.pathname,
  //     search: search + '&topic=' + topic
  //   })
  // }, [topic]);

  const handleChange = (topicKey) => {
    setTopic(topicKey);
    let search = removeURLParameter(props.location.search, 'topic');
    props.history.push({
      pathname: props.location.pathname,
      search: search + '&topic=' + topicKey
    });
  }

  return (
    <Layout location={props.location.search}>
      <Container>
        <Tabs
          defaultActiveKey={topic}
          onSelect={(k) => handleChange(k)}
        >
          <Tab eventKey="creditpool" title="Créditer des cagnottes">
            <CreditPool/>
          </Tab>
          <Tab eventKey="message" title="Message SMS ou Email">
            <Message/>
          </Tab>
          <Tab eventKey="reclasser" title="Reclasser des SAV" mountOnEnter>
            <Reclasser savId={savId}/>
          </Tab>
          <Tab
            eventKey="intendance"
            title={
              <>
                Intendance charrette{" "}
                <OverlayTrigger
                  placement="right"
                  overlay={
                    <Tooltip id="intendance-alpha-tooltip">
                      Ceci est une interface non définitive, en test et qui peut être
                      amenée à changer radicalement en fonction des retours.
                      Elle mérite une vigilance accrue sur la cohérence des données
                      et les bugs éventuels.
                    </Tooltip>
                  }
                >
                  <AlphaBadge variant="warning">
                    EN ALPHA <span aria-hidden="true">?</span>
                  </AlphaBadge>
                </OverlayTrigger>
              </>
            }
            mountOnEnter
          >
            <Intendance/>
          </Tab>
        </Tabs>
      </Container>

      <HelpDocumentation title="Documentation sur le sav" url="https://moulindev.freshdesk.com/support/solutions/folders/48000667291"/>
    </Layout>
  );
};

const Container = styled.div`
  padding: 1rem;
`;

// Badge « En alpha » sur l'onglet Intendance : rappel que l'interface est en test,
// explication au survol
const AlphaBadge = styled(Badge)`
  cursor: help;

  span {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 13px;
    height: 13px;
    margin-left: 3px;
    border-radius: 50%;
    background: rgba(0, 0, 0, 0.18);
    font-size: 9px;
  }
`;

Sav.propTypes = {};

Sav.defaultProps = {};

export default Sav;
